<template>
  <div class="ai-information-tab">
    <div class="ai-information-tab__header">
      <span v-if="hasAssessments">
        {{ $t("issues.aida_deterioration_mechanisms") }}:
      </span>
      <span v-else>
        {{ $t("issues.aida_no_deterioration_mechanisms") }}
      </span>
    </div>

    <div v-if="hasAssessments">
      <div
        v-for="detMech in Object.keys(currentImage.ai_assessment)"
        :key="detMech"
        class="ai-information-tab__det-mech-row"
      >
        <span>
          {{ $t(`deterioration_mechanisms.${detMech}.name`) }}
        </span>
        <div class="ai-information-tab__det-mech-indicator">
          <span class="ai-information-tab__det-mech-icon">
            <RatingCircle
              :class="[
                'icon',
                'icon--tiny',
                `${conditionIconClass(currentImage.ai_assessment[detMech])}`,
              ]"
              name="rating_circle"
            />
          </span>
          <span class="ai-information-tab__det-mech-rating">
            {{ currentImage.ai_assessment[detMech] }}
          </span>
        </div>
      </div>
    </div>
    <div class="ai-information-tab__confirm-warning">
      <div class="ai-information-tab__confirm-warning-icon">
        <IEncircled />
      </div>
      <div class="ai-information-tab__confirm-warning-message">
        {{ $t("issues.aida_warning") }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import IEncircled from '@/images/i_encircled-16.svg';
import RatingCircle from '@/images/rating-circle-16.svg';

const props = defineProps({
  /** The currently selected image object */
  currentImage: { type: Object, required: true },
});

const hasAssessments = computed(() => {
  return props.currentImage?.ai_assessment;
});

function conditionIconClass(rating) {
  return `issue-ratings__indicator--condition-${rating}`;
}
</script>

<style lang="scss" scoped>
@import "@/stylesheets/global";

.ai-information-tab {
  padding: 0 bu(0.3);
  font-size: bu(1.625);

  &__header {
    padding-right: bu(2);
    padding-bottom: bu(1);
  }

  &__det-mech-row {
    display: flex;
    justify-content: space-between;
    padding-bottom: bu(1.5);
    padding-top: bu(1.25);
    border-bottom: bu(0.2) solid map-get($background-color, lighter);
  }

  &__det-mech-indicator {
    display: flex;
    align-items: center;
  }

  &__det-mech-rating {
    @include set-font-family("condensed-tabular-numbers");
    display: flex;
    align-items: center;
    font-weight: 700;
    margin-left: bu(1.5);
    color: map-get($foreground-color, light);
  }

  &__confirm-warning {
    display: flex;
    border: bu(0.15) solid #eb6c0e;
    border-radius: map-get($border-radius, heavy);
    background-color: map-get($error-color, shade);
    color: map-get($foreground-color, light);
    margin-top: bu(3);
  }

  &__confirm-warning-icon {
    display: flex;
    align-items: flex-start;
    padding: bu(1.75) bu(1.75) 0 bu(2.5);
    color: map-get($orange-color, default);
  }

  &__confirm-warning-message {
    padding: bu(1.6) bu(1.75) bu(2) 0;
    font-size: bu(1.7);
  }
}
</style>
